import featureReducer from './reducers';

export { default as featureTypes } from './types';
export { default as featureActions } from './actions';
export { default as featureSagas } from './sagas';

export default featureReducer;
